import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { useLazyQuery } from '@apollo/react-hooks';

import { Icon, Tooltip, Button, showToast } from '../core-ui';
import { DOWNLOAD_BUTTON } from '../constants/colors';
import downloadData from '../helpers/downloadData';
import json2csv from '../helpers/json2csv';
import { GenerateJSON } from '../generated/GenerateJSON';
import { GenerateDBO } from '../generated/GenerateDBO';
import {
  EXPORT_CSV_QUERY,
  SPECIAL_CSV_QUERY,
} from '../graphql/queries/overview';
import { normalizeJsonCSV, normalizeDBOCSV } from '../helpers/normalizeData';

type Props = {
  isDBO?: boolean;
};

export default function ExportCSV(props: Props) {
  let { isDBO } = props;
  let [callExportCSV, { loading, data: jsonDataRaw }] = useLazyQuery<
    GenerateJSON
  >(EXPORT_CSV_QUERY, {
    fetchPolicy: 'network-only',
    onError: (error) => {
      showToast({
        message: `${error.message}`,
        duration: 3500,
      });
    },
  });

  let [download, isDownload] = useState(false);
  let [
    callSpecialExportCSV,
    { loading: specialLoading, data: jsonDataSpecial },
  ] = useLazyQuery<GenerateDBO>(SPECIAL_CSV_QUERY, {
    fetchPolicy: 'network-only',
    onError: (error) => {
      showToast({
        message: `${error.message}`,
        duration: 3500,
      });
    },
  });

  let jsonData;

  if (jsonDataSpecial) {
    jsonData = jsonDataSpecial && normalizeDBOCSV(jsonDataSpecial);
  } else {
    jsonData = jsonDataRaw && normalizeJsonCSV(jsonDataRaw);
  }

  if (jsonData && download) {
    let csv = json2csv(jsonData);
    let csvBlob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    downloadData(csvBlob, 'File.csv');
    isDownload(false);
  }

  let exportCSV = () => {
    if (isDBO) {
      isDownload(true);
      callSpecialExportCSV();
    } else {
      isDownload(true);
      callExportCSV();
    }
  };

  return (
    <Tooltip
      content="To view the details of the tasks and resources for this project click here"
      offset={{
        right: 0,
        top: 55,
      }}
      containerStyle={{
        width: 230,
      }}
    >
      <Button
        buttonMode="secondary"
        title="Export"
        style={styles.container}
        onPress={exportCSV}
        labelStyle={styles.text}
        icon={() => <Icon name="exportIcon" size="xsmall" />}
        disabled={loading || specialLoading}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  container: {
    minWidth: 0,
    width: 109,
    borderRadius: 8,
    borderColor: DOWNLOAD_BUTTON.border,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: DOWNLOAD_BUTTON.text,
    fontSize: 16,
    marginLeft: 5,
  },
});
